var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',[_c('v-card-title',[_c(_setup.EntWorkflowNavBar,{attrs:{"args":_setup.wNav,"buttonclick":_setup.navbuttons,"title":_setup.wTitle},on:{"update:buttonclick":function($event){_setup.navbuttons=$event}}})],1),_c(_setup.ClonePlantSearch),_c('v-card-text')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }